module.exports = __webpack_public_path__ + "img/west-vvip-gal-2.41fb028d.jpg";